import React from "react"
import { motion } from 'framer-motion'
const Card = (props) => {
  return (
    <>
     <motion.div
  whileInView={{x:[-100,0],opacity:[0,1]}}
  transition={{duration:0.5}}
 >
      <div className='box btn_shadow'>
        <div className='title_content d_flex'>
          <div className='title'>
            <h2>{props.title}</h2>
            <span>{props.year}</span>
          </div>
          <div className='rate'>
            <button className='btn_shadow '>{props.rate}</button>
          </div>
        </div>
        <hr />
        <p>{props.desc}</p>
      </div>
      </motion.div>
    </>
  )
}

export default Card
